import React from "react";
import BasicModal from "../../../../Components/Modals/BasicModal";
import Btn from "../../../../Components/Buttons/Btn";
import { RiDeleteBin5Line } from "react-icons/ri";
import useAxios from "../../../../Hooks/useAxios";

const ApproveModal = ({
  showApproveModal,
  setShowApproveModal,
  selectedRequestId,
  fetchRequests, // optional: to refresh list after approval
}) => {
  const request = useAxios();

  const handleApprove = async () => {
    const res = await request({
      method: "PUT",
      url: `requests/approve?id=${selectedRequestId}`,
    });

    if (res === "error") return;

    setShowApproveModal(false);
    if (fetchRequests) fetchRequests(); 
  };

  if (!showApproveModal) return null;

  return (
    <BasicModal
      showModal={showApproveModal}
      setShowModal={setShowApproveModal}
      header="Approve Request"
    >
      <div className="m-auto p-5">
        <h2 className="text-center text-red text-xl font-bold mb-6">
          Are you sure you want to approve this request?
        </h2>
        <div className="flex justify-between items-center">
          <Btn
            outline={true}
            btn="border"
            onClick={() => setShowApproveModal(false)}
          >
            <p>Cancel</p>
          </Btn>
          <Btn outline={true} btn="border" onClick={handleApprove}>
            <div className="flex justify-between items-center gap-x-2">
              <RiDeleteBin5Line className="text-red" />
              <p>Confirm</p>
            </div>
          </Btn>
        </div>
      </div>
    </BasicModal>
  );
};

export default ApproveModal;
